import React, { useState } from 'react';

import { alpha, Stack, Tab, Tabs } from '@mui/material';

import { useAppBuilderContext } from 'app/app/editor/context';
import SettingsEditor from './SettingsEditor';
import CssEditor from './CssEditor';
import StylesEditor from './StylesEditor';
import useBundleTranslation from 'i18n';
import { getNodeByUid } from 'app/app/editor/page/getNodeByUid';
import AttributesEditor from 'app/app/editor/tabs/settings/AttributesEditor';
import StyleVariablesEditor from 'app/app/editor/tabs/settings/StyleVariablesEditor';
type ElementSubTabType = 'settings' | 'styles' | 'css' | 'attributes' | 'css_variables';

export default function SettingsTab({ componentUid }: { componentUid: string | null }) {
    const { t } = useBundleTranslation(['app/portal-page-builder']);
    const ctx = useAppBuilderContext();
    const [page] = [ctx.page];

    const isComponent = null !== componentUid && page?.components?.[componentUid];
    const [activeTab, setActiveTab] = useState<ElementSubTabType>(isComponent ? 'settings' : 'styles');
    const editNode = componentUid == 'page' ? ctx.page.layout : getNodeByUid(ctx.page.layout, componentUid ?? '');

    const tabs: Array<ElementSubTabType> = [];
    if (isComponent) {
        tabs.push('settings');
    }
    if (!ctx.withTemplate) {
        tabs.push('styles');
        // MI-26836: CSS tab temporary hidden
        // tabs.push('css');
        tabs.push('attributes');
        if (componentUid == 'page') tabs.push('css_variables');
    }

    if (!editNode) return null;

    return (
        <Stack height={1}>
            <Stack
                direction={'row'}
                sx={{
                    flexShrink: 0,
                    alignItems: 'center',
                    borderBottom: (theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
                    borderTop: (theme) => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
                    '.MuiTabs-root': { minHeight: 0 },
                    '.MuiTab-root': {
                        padding: '4px 6px',
                        minHeight: 0,
                    },
                }}
                flexShrink={0}
            >
                <Tabs
                    value={activeTab}
                    onChange={(event: React.SyntheticEvent, newValue: ElementSubTabType) => {
                        setActiveTab(newValue);
                    }}
                >
                    {tabs.map((tab: any) => (
                        <Tab label={t(`setting_tabs.${tab}`)} key={tab} value={tab} />
                    ))}
                </Tabs>
            </Stack>
            <Stack sx={{ p: 2, flexGrow: 1, overflow: 'auto' }}>
                {'settings' == activeTab && isComponent && <SettingsEditor node={editNode} />}
                {'styles' == activeTab && <StylesEditor node={editNode} />}
                {'css' == activeTab && <CssEditor componentUid={editNode.params.uid} />}
                {'attributes' == activeTab && <AttributesEditor node={editNode} />}
                {'css_variables' == activeTab && <StyleVariablesEditor node={editNode} />}
            </Stack>
        </Stack>
    );
}
